import {Component, Input, OnInit, ViewChild} from '@angular/core';
import {MessageUserType} from '../../../../work-plan-and-targets/store/work-plan-and-targets.model';
import {
  createGrantWorkflow, createInternalCommentHistory, createInternalCommentHistoryForm, InternalCommentHistory,
  ReviewMessageActionType,
  ReviewStepType,
} from '../../../../grant-workflow/store/grant-workflow.model';
import {NgbActiveModal, NgbModalOptions} from '@ng-bootstrap/ng-bootstrap';
import {FormBuilder, FormGroup} from '@angular/forms';
import {Observable} from 'rxjs';
import {SessionQuery} from '../../../../../shared/stores/session/session.query';
import {GrantWorkflowService} from '../../../../grant-workflow/store/grant-workflow.service';
import {LoadingService} from '../../../../../shared/modules/shared-common/services/loading/loading.service';
import {take} from 'rxjs/operators';
import {AlertService} from '../../../../../shared/modules/alert/services/alert.service';

@Component({
  selector: 'app-review-message-modal',
  templateUrl: './review-message-modal.component.html',
  styleUrls: ['./review-message-modal.component.scss']
})
export class ReviewMessageModalComponent implements OnInit {

  @Input() action: ReviewMessageActionType;
  @Input() step: ReviewStepType;
  @Input() workflowId: number;

  options: NgbModalOptions;
  profileForm: FormGroup;
  isLoading: Observable<boolean>;

  constructor(public activeModal: NgbActiveModal,
              private sessionQuery: SessionQuery,
              private formBuilder: FormBuilder,
              private alertService: AlertService,
              private workflowService: GrantWorkflowService,
              private loadingService: LoadingService) {
  }

  ngOnInit() {
    this.isLoading = this.loadingService.getIsLoading();
    this.options = {
      ariaLabelledBy: 'Message',
      centered: true
    };
    const username = this.sessionQuery.getUser().username;

    const comment = createInternalCommentHistory({
      workflow: createGrantWorkflow({id: this.workflowId}),
      username,
      userType: this.getUserType(),
      date: Date.now(),
      action: this.action,
      message: ''
    });

    this.profileForm = createInternalCommentHistoryForm(this.formBuilder, comment);
  }

  private getUserType(): MessageUserType {
    const roles = this.sessionQuery.getRoles();

    if (roles.includes('ROLE_ADMIN')) {
      return MessageUserType.ADMIN;
    } else if (roles.includes('ROLE_FUNDER')) {
      return MessageUserType.FUNDER;
    } else if (roles.includes('ROLE_GRANT_MANAGER')) {
      return MessageUserType.MANAGER;
    } else if (roles.includes('ROLE_GRANT_COORDINATOR')) {
      return MessageUserType.COORDINATOR;
    }
  }

  closeModal(reason?: string) {
    this.activeModal.close(reason);
  }

  update(form: FormGroup) {
    const value: InternalCommentHistory = form.value;

    if (form.valid) {
      this.loadingService.setIsLoading(true);
      this.workflowService.updateReviewStep(this.workflowId, this.step, value)
        .pipe(take(1)).subscribe(() => {
        this.loadingService.setIsLoading(false);
        this.closeModal('saved');
      }, error => {
        this.alertService.setAlert(
          (error && error.error && error.error.message) || 'Failed to update review step',
          'error',
          'reviewMessageModal'
        );
      });
    } else {
      this.alertService.setAlert('Message is required.', 'error', 'reviewMessageModal');
    }
  }
}
